<template>
  <v-menu
    bottom
    left
    min-width="200"
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        class="ml-2"
        min-width="0"
        text
        v-bind="attrs"
        v-on="on"
      >
        <v-icon color="accent">mdi-account</v-icon>
      </v-btn>
    </template>

    <v-list
      :tile="false"
      flat
      nav
    >
      <app-bar-item
        to="/components/profile/"
      >
        <v-list-item-title
          v-if="users.authState === 'signedin' && users.user"
        >
          {{ users.user.attributes.name }}'s Profile
        </v-list-item-title>
      </app-bar-item>

      <v-divider
        class="mb-2 mt-2"
      />

      <v-list-item-title>
        <v-btn
          color="primary"
          class="font-weight-medium text-body-1"
          style="width: 100%;"
          @click="signOut"
        >
          SIGN OUT
        </v-btn>
      </v-list-item-title>
    </v-list>
  </v-menu>
</template>

<script>
  import { get } from 'vuex-pathify'
  import { Auth } from 'aws-amplify'

  export default {
    name: 'DefaultAccount',

    data () {
      return {
      }
    },

    computed: {
      users: get('user/users'),
    },

    methods: {
      async signOut () {
        try {
          await Auth.signOut()
          await this.$store.dispatch('user/setAuth', { authState: 'signedout', authData: undefined })
        } catch (error) {
          console.error('error signing out: ', error)
        }
      },
    },
  }
</script>

<style lang="scss">
:root {
  /*
  --amplify-primary-color: var(--v-primary-base);
  --amplify-primary-tint: #ffac31;
  --amplify-primary-shade: #e88b01;
  */
}
</style>
